module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forecastNameWrapper",
    style: ({
      backgroundColor: _vm.statusColor
    })
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.forecast.reference) + " • " + _vm._s(_vm.forecast.name))])]), _vm._v(" "), _c('div', {
    staticClass: "status-container"
  }, [(_vm.forecast.isTransmissionApproved === true) ? _c('div', {
    staticClass: "state"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm.statusName))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fas fa-check"
  }), _vm._v(" "), _c('span', [_vm._v("Approved")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2edfd7c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/general/ForecastNameBanner.vue
// module id = 3101
// module chunks = 0